<template>
    <div>
        <div class="area-container">
            <div v-for="(item, index) in tableArea" :key="index">
                <div
                    class="area-item"
                    :class="{ active: item.guid == activeTableAreaGuid }"
                    @click="changeTable(item.guid)"
                >
                    {{ item.name }}
                </div>
            </div>
        </div>
        <div class="table-title">{{ $t("table.table") }}</div>
        <!-- begin loading -->
        <div v-if="pageLoading" class="page-loading-container">
            <v-progress-circular
                :size="60"
                :width="5"
                color="primary"
                indeterminate
            ></v-progress-circular>
        </div>
        <!-- end loading -->
        <div class="table-container" v-show="!pageLoading">
            <div
                v-for="(item, index) in tableList"
                :key="index"
                class="table-item"
                :class="{ active: item.status == 0 }"
                @click="goToTableOrder(item)"
            >
                <div class="name">{{ item.name }}</div>
                <div class="status">{{ item.statusText }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from "vuex";
import Store from "../../api/store";

export default {
    data() {
        return {
            pageLoading: false
        };
    },

    created() {
        if (this.$route.query.token) {
            this.setTokenContent(this.$route.query.token);
            this.getTableArea();
        }
        if (this.$route.query.storeGuid) {
            this.setStoreId(this.$route.query.storeGuid);
            this.getStoreInfo();
        }

        if (this.$route.query.from) {
            this.closeCookie();
        }

        this.setPageFrom(this.$route.query.from || "");

        if (this.$route.query.lang) {
            this.setLang(this.$route.query.lang);
        }

        const lang = this.$route.query.lang;

        if (lang == "zh" || lang == "zh-CN") {
            this.$i18n.locale = "zh-CN";
        } else {
            this.$i18n.locale = "es-ES";
        }
    },

    computed: {
        ...mapState(["tableArea", "activeTableAreaGuid", "tableList"])
    },

    methods: {
        ...mapMutations([
            "setTokenContent",
            "setStoreId",
            "setTableArea",
            "setActiveTableAreaGuid",
            "setTableList",
            "setLang",
            "setPageFrom",
            "closeCookie",
            "setMyOrder"
        ]),
        ...mapActions(["getStoreInfo"]),

        changeTable(guid) {
            this.setActiveTableAreaGuid(guid);
            this.getTableList();
        },

        async getTableArea() {
            try {
                const {
                    data: {isError, data}
                } = await Store.getTableArea({});

                if (isError) {
                    return;
                }

                this.setTableArea(data);

                if (!this.activeTableAreaGuid) {
                    this.setActiveTableAreaGuid(data[0].guid);
                }
                this.getTableList();
            } catch (e) {
                console.log(e);
            }
        },

        async getTableList() {
            this.pageLoading = true;
            try {
                const {
                    data: {isError, data}
                } = await Store.getTableList({
                    areaGuid: this.activeTableAreaGuid,
                    pageSize: 999
                });

                if (isError) {
                    return;
                }
                this.pageLoading = false;

                this.setTableList(data.collection);
            } catch (e) {
                console.log(e);
            }
        },

        goToTableOrder(item) {
            this.setMyOrder({
                items: []
            });
            this.$router.push({
                name: "delivery/list",
                query: {
                    codeType: "table",
                    tableGuid: item.guid,
                    tableNum: item.name,
                    storeId: this.$route.query.storeGuid
                }
            });
        }
    }
};
</script>

<style scoped lang="sass" src="./list.sass"></style>
